/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import Footer from "./Components/common/Footer";
import Header from "./Components/common/Header";
import CustomRoutes from "./router/CustomRoutes";
import { useTranslation } from "react-i18next";
import { HelmetProvider } from 'react-helmet-async';

function AppContent({ changeLanguage }) {
  const location = useLocation();
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  
  // Ürün sayfalarında galeriyi gizle
  const productPages = [
    '/urunlerimiz',
    '/ProductDetails',
    '/ProductSimilar',
    '/ProductSimilarGida'
  ];
  
  const isProductPage = productPages.some(page => 
    location.pathname.includes(page)
  );

  // Lightbox durumunu kontrol et
  useEffect(() => {
    const checkLightbox = () => {
      const lightboxElement = document.querySelector('.SRLLightbox');
      const isOpen = lightboxElement && lightboxElement.style.display !== 'none';
      setIsLightboxOpen(isOpen);
    };

    // MutationObserver ile DOM değişikliklerini izle
    const observer = new MutationObserver(checkLightbox);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    // İlk kontrol
    checkLightbox();

    return () => observer.disconnect();
  }, []);

  // Galeriyi gizle: ürün sayfalarında VEYA lightbox açıkken
  const shouldHideGallery = isProductPage || isLightboxOpen;

  return (
    <>
      <Header changeLanguage={changeLanguage} />
      <CustomRoutes changeLanguage={changeLanguage} />
      <Footer changeLanguage={changeLanguage} showGallery={!shouldHideGallery} />
    </>
  );
}

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const userLanguage = navigator.language || navigator.userLanguage;
    if (userLanguage.includes("tr")) {
      i18n.changeLanguage("tr"); // Tarayıcı dilini Türkçe olarak algıladığında dil ayarınızı güncelleyin
    }
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppContent changeLanguage={changeLanguage} />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
